// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .featuredItem {
  flex: 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor:default;
  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
} */

.previoussurvey_container_surveys__A\\+Spz {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  
  justify-content: space-around;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}


.previoussurvey_surveys_content__KkPSD {

  justify-content: space-around;
  background-color: var(--hsrcBackgroundLight);
    vertical-align: "top";
    flex-direction: row;
    align-content: flex-start;
    align-items: left;
    align-self: flex-start;
    margin-left: 5%;
}

.previoussurvey_divider__TGLQP {
  width: 100%;
  height: 0px;
  margin-top: 30px;
  margin-bottom: 30px;
  border: 1px solid var(--hsrcLightDark); 
}

.previoussurvey_printviewDialog__X31Rv {
  min-width: 90vw !important;
  max-width: 90vw !important;
}

.previoussurvey_confirmDialogOverlay__fVmPH {
  z-index: 10000; 
  pointer-events: none;
}


.previoussurvey_download__E0wEd{
  background-color: var(--hsrcDarkBlue);
  color: var(--hsrcLightDark);
}

.previoussurvey_breadcrumbs__MuZbm{
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  background-color: var(--hsrcBackgroundLight);
  padding-bottom: 4.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/PreviousSurvey/previoussurvey.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;GAaG;;AAEH;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;;EAEzB,6BAA6B;EAC7B,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;;AAGA;;EAEE,6BAA6B;EAC7B,4CAA4C;IAC1C,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;EAC5C,sBAAsB;AACxB","sourcesContent":["/* .featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor:default;\r\n  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n} */\r\n\r\n.container_surveys {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  \r\n  justify-content: space-around;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n\r\n.surveys_content {\r\n\r\n  justify-content: space-around;\r\n  background-color: var(--hsrcBackgroundLight);\r\n    vertical-align: \"top\";\r\n    flex-direction: row;\r\n    align-content: flex-start;\r\n    align-items: left;\r\n    align-self: flex-start;\r\n    margin-left: 5%;\r\n}\r\n\r\n.divider {\r\n  width: 100%;\r\n  height: 0px;\r\n  margin-top: 30px;\r\n  margin-bottom: 30px;\r\n  border: 1px solid var(--hsrcLightDark); \r\n}\r\n\r\n.printviewDialog {\r\n  min-width: 90vw !important;\r\n  max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n  z-index: 10000; \r\n  pointer-events: none;\r\n}\r\n\r\n\r\n.download{\r\n  background-color: var(--hsrcDarkBlue);\r\n  color: var(--hsrcLightDark);\r\n}\r\n\r\n.breadcrumbs{\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n  align-content: center;\r\n  justify-content: flex-start;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  padding-bottom: 4.5rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_surveys": `previoussurvey_container_surveys__A+Spz`,
	"surveys_content": `previoussurvey_surveys_content__KkPSD`,
	"divider": `previoussurvey_divider__TGLQP`,
	"printviewDialog": `previoussurvey_printviewDialog__X31Rv`,
	"confirmDialogOverlay": `previoussurvey_confirmDialogOverlay__fVmPH`,
	"download": `previoussurvey_download__E0wEd`,
	"breadcrumbs": `previoussurvey_breadcrumbs__MuZbm`
};
export default ___CSS_LOADER_EXPORT___;
